import axios from "axios";

// Resolve backend base URL.
// Strategy: PREFER same-origin (window.location.origin) so that requests always
// hit the ingress that proxies /api/* to the backend within the current domain.
// This avoids CORS+credentials breakage when REACT_APP_BACKEND_URL points to a
// different host than the one the user is browsing on (e.g. preview URL baked
// into a production build).
function resolveBackend() {
    const envUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
    if (typeof window === "undefined") return envUrl;
    const here = window.location.origin;
    // If the env URL matches the current origin OR is empty, use it directly.
    if (!envUrl || envUrl === here) return envUrl || here;
    // Otherwise default to same-origin to avoid CORS.
    return here;
}

const BACKEND_URL = resolveBackend();
export const API = `${BACKEND_URL}/api`;

// Auth state lives entirely in httpOnly cookies set by the backend on login.
// We never store the JWT in localStorage (vulnerable to XSS).
export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export const imageUrl = (path) => (path ? `${API}/images/${path}` : null);

export const formatRupiah = (n) => {
    const num = Number(n) || 0;
    return "Rp " + num.toLocaleString("id-ID", { maximumFractionDigits: 0 });
};

// Format discount percentage as "XX,XX" (Indonesian convention: comma as decimal).
// Always shows 2 digits after the comma.
export const formatDiscount = (n) => {
    const num = Number(n) || 0;
    return num.toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const errorMessage = (e) => {
    const d = e?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
    if (d?.msg) return d.msg;
    return e?.message || "Terjadi kesalahan";
};
